/**
 * @generated SignedSource<<7fe537cfc96d4d2dea42a395b60a4720>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildApprovalDetailsPopup_anchor$data = {
  readonly status: string | null | undefined;
  readonly " $fragmentType": "BuildApprovalDetailsPopup_anchor";
};
export type BuildApprovalDetailsPopup_anchor$key = {
  readonly " $data"?: BuildApprovalDetailsPopup_anchor$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildApprovalDetailsPopup_anchor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildApprovalDetailsPopup_anchor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "ApprovalInfo",
  "abstractKey": null
};

(node as any).hash = "e45f53aa479e3e8f4ebe814b751c846c";

export default node;
